import React from "react";
import {useTranslation} from "react-i18next";
import Flashbar, { FlashbarProps } from "@awsui/components-react/flashbar";


interface SubmitFlashbarProps {
    submitMessage: FlashbarProps.MessageDefinition | undefined;
    setSubmitMessage: (value: FlashbarProps.MessageDefinition | undefined) => void;
}

const SubmitFlashbar: React.FC<SubmitFlashbarProps> = (props: SubmitFlashbarProps) => {
    const {t} = useTranslation("common");
    return (
        <Flashbar
            items={[{
                ...props.submitMessage,
                dismissible: true,
                dismissLabel: t("buttons.dismiss"),
                onDismiss: () => props.setSubmitMessage(undefined)
            }]}
        />
    );
};

export default SubmitFlashbar;
